import { axiosCore } from './http-core-service';
import { MailDto } from './dtos/mail.dto';
import { ContactsDto } from './dtos/contacts.dto';

type SendMailPayload = MailDto & {
    copy?: boolean;
};

let contactsRequest: Promise<ContactsDto[]> | null = null;

/**
 * Méthode qui récupère les contacts de l'utilisateur
 */
export const getContacts = async () => {
    if (!contactsRequest) {
        contactsRequest = axiosCore
            .get<ContactsDto[]>(`/api/contacts/list`)
            .then(response => response.data)
            .finally(() => {
                contactsRequest = null;
            });
    }

    return contactsRequest;
};

/**
 * Méthode qui permet d'envoyer un mail à un contact
 * @param file file
 * @param e mailDto
 * @param mandateId identifiant du mandat
 */
export const sendMail = async (file: string | Blob, e: SendMailPayload, mandateId?: string) => {
    //Ajout du critère
    let criterions = '';
    if (mandateId) {
        criterions += `?mandateId=${mandateId}`;
    }

    // Création du body de type formData
    const formData = new FormData();
    formData.append('files', file);
    formData.append(
        'infos-mail',
        JSON.stringify({ recipients: e.recipients, title: e.title, content: e.content, copy: Boolean(e.copy) })
    );
    const response = await axiosCore.post(`/api/contacts/mail${criterions}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};
